const toPlan = (data) => {
  if (Array.isArray(data)) return data[0] ?? null;
  if (data?.id) return data;
  return null;
};

export const normalizeCoverFilterQuote = (data, meta) => {
  const plan = toPlan(data);
  if (!plan?.options?.length) return null;

  const covers = {};
  const total_price = {};

  plan.options.forEach((opt) => {
    const key = opt.option_type;
    covers[key] = (opt.age_pricing || []).map((a) => a.pricing_id);
    total_price[key] = opt.total_premium;
  });

  const first = plan.options[0];

  return {
    covers,
    total_price,
    currency: first.currency || "INR",
    currency_symbol: first.currency_symbol || "Rs",
    quote_data: {
      nationality: meta.nationality,
      travelling_from: meta.travelling_from,
      travelling_to: meta.travelling_to,
      start_date: meta.start_date,
      end_date: meta.end_date,
      age_fields: meta.ages,
      adventure: [meta.cover_id],
      ...(meta.residence_status && { residence_status: meta.residence_status }),
    },
    plan,
  };
};
